<div [class.ng-hide]="!isCurrent"
     [id]="'checkout-step-' + name">
    <ng-content select="[step-body]" />
</div>
<div [class.ng-hide]="!displayStatus && !displayStatusTitle">
    @if (statusTitle && displayStatusTitle) {
    <div class="flex flex-middle flex-justify-between">
        <div class="flex flex-middle">
            <p class="p1">{{statusTitle}}</p>
            <ng-content select="[step-save-status]" />
        </div>
        <ng-content select="[step-title]" />
    </div>
    }
    <div class="m-t-2 p-a-2 p-a-4-m p-a-4-s flex flex-justify-between flex-top b-radius-7 bg-col-5"
         [class.ng-hide]="!displayStatus">
        <div class="flex-grow">
            <ng-content select="[step-status]" />
        </div>
        @if (showLogout) {
        <div class="flex flex-middle">
            @if (logoutStatus.busy) {
            <i class="m-r icon-loading"
               aria-hidden="true"></i>
            }
            <button [class.disabled]="previousIsBusy"
                    type="button"
                    (click)="logout()">
                <span [sizeClass]="'SM: fs-3 fw-bold, XL: s2'">{{'Sign out' | translate}}</span>
            </button>
        </div>
        }
        @if (!showLogout) {
        <button [class.disabled]="previousIsBusy"
                type="button"
                (click)="change()">
            <span [sizeClass]="'SM: fs-3 fw-bold, XL: s2'">{{'Change' | translate}}</span>
        </button>
        }
    </div>
</div>
